var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import { getHotList } from '../utils/api';
import { rel } from '../utils/rel';
import CommentInput from './commentInput';
import HotList from './hotList';
class Comment extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hotListData: {
                count: 0,
                join_count: 0,
                comments: [],
                allow_comment: -1,
            },
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { articleInfo } = this.props;
            const { cmtNumUrl, docUrl, skey, hotLimit } = articleInfo;
            try {
                const hotListData = yield getHotList(cmtNumUrl, docUrl, skey, hotLimit);
                this.setState({
                    hotListData,
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    render() {
        const { hotListData } = this.state;
        const { articleInfo } = this.props;
        if (hotListData.allow_comment === -1)
            return null;
        const voteData = {
            cmtVoteUrl: articleInfo.cmtVoteUrl,
            docUrl: articleInfo.docUrl,
        };
        let commentUrl = `//gentie.ifeng.com/view.html?docUrl=${articleInfo.docUrl}&docName=${articleInfo.docTitle}&skey=${articleInfo.skey}&speUrl=&pcUrl=${articleInfo.pcUrl}${articleInfo.noAd ? '&noAd' : ''}`;
        if (articleInfo.docUrl) {
            commentUrl = `//gentie.ifeng.com/c/comment/${articleInfo.docUrl.replace('ucms_', '')}`;
        }
        return (React.createElement("div", { className: styles.comment_box },
            React.createElement("div", { className: styles.title },
                React.createElement("span", null, "\u70ED\u95E8\u8BC4\u8BBA")),
            hotListData.comments.length > 0 ? (React.createElement(HotList, { content: hotListData.comments, commentUrl: commentUrl, voteData: voteData })) : (React.createElement("div", { className: styles.bg_box })),
            (articleInfo.commentOpen === undefined || articleInfo.commentOpen) && (React.createElement(CommentInput, { articleInfo: articleInfo })),
            hotListData.join_count && hotListData.join_count !== 0 ? (React.createElement("div", { className: styles.counts },
                React.createElement("a", { href: commentUrl, target: "_blank", rel: rel },
                    "\u67E5\u770B\u5168\u90E8",
                    hotListData.join_count,
                    "\u6761\u8BC4\u8BBA"),
                React.createElement("span", null))) : ('')));
    }
}
Comment.defaultProps = {
    articleInfo: {
        cmtLength: 1000,
        hotLimit: 2,
    },
};
export default Comment;
